import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import { customFormValidators, isSome } from 'core/utils';
import _ from 'lodash';

class FormBase extends Form {
	form = null;

	constructor(hooks) {
		super(
			{},
			{
				hooks,
				options: {
					validationDebounceWait: 50,
				},
			}
		);
	}

	setForm = form => {
		this.form = form;
	};

	onDeleteArrayField = (e, arrayField, arrayForm, callback = null) => {
		this.form.$(arrayField.path).onDel(e);
		if (arrayForm.size == 0) {
			arrayForm.value = [];
		}

		if (callback) {
			callback(arrayField);
		}
	};

	// Form.update() method is not working correctly
	updateForm = (item, deepUpdate = false) => {
		const fieldsToAdd = [];
		this.form.each(field => {
			if (isSome(item[field.key])) {
				if (_.isObject(item[field.key])) {
					if (_.isArray(item[field.key]) >= 1 && deepUpdate) {
						const fieldToAdd = { field, values: [] };
						_.each(item[field.key], val => {
							if (!val.label && !val.name) {
								fieldToAdd.values.push(val);
							}
						});
						fieldsToAdd.push(fieldToAdd);
					}
				}
				field.set('value', item[field.key]);
			}
		});
		_.each(fieldsToAdd, ({ field, values }) => {
			_.each(values, value => {
				field.add(value);
				field.set('value', item[field.key]);
			});
		});
	};

	clearRules = (fieldKeys = []) => {
		_.each(fieldKeys, key => {
			this.form.$(key).set('rules', '');
		});
	};

	setFieldRules = (fieldKeys = [], rules) => {
		_.each(fieldKeys, key => {
			this.form.$(key).set('rules', rules);
		});
	};

	plugins() {
		return {
			dvr: dvr({
				package: validatorjs,
				extend: ({ validator }) => {
					Object.keys(customFormValidators).forEach(name => {
						const customValidator = customFormValidators[name];
						validator.register(name, customValidator.rule, customValidator.message);
					});
					var messages = validator.getMessages('en');
					messages.required = 'MESSAGES.REQUIRED.:attribute';
					messages.email = 'MESSAGES.EMAIL.:attribute';
					messages.min.string = 'MESSAGES.MIN.:attribute';
					messages.max.string = 'MESSAGES.MAX.:attribute';
					messages.same = 'MESSAGES.SAME.:attribute';
					messages.different = 'MESSAGES.DIFFERENT.:attribute';
					messages.between = 'MESSAGES.BETWEEN.:attribute';
					messages.numeric = 'MESSAGES.NUMERIC.FILTER.NUMBER';
					messages.integer = 'VALIDATORJS.INTEGER';
					messages.min.numeric = 'MESSAGES.MIN.:attribute';
					validator.setMessages('en', messages);
				},
			}),
		};
	}

	options() {
		return {
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		};
	}
}

export default FormBase;



// WEBPACK FOOTER //
// ./src/core/components/forms/base/FormBase.js